import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import LookingFor from "@/pages/LookingFor";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

const SITE_TITLE = "T3 Solutions | Tech Tactics Talent";

function TitleEnforcer() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = SITE_TITLE;
    const enforce = () => {
      if (document.title !== SITE_TITLE) document.title = SITE_TITLE;
    };
    const observer = new MutationObserver(enforce);
    const titleEl = document.querySelector("title");
    if (titleEl) observer.observe(titleEl, { childList: true });
    const interval = setInterval(enforce, 1500);
    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <TitleEnforcer />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/looking-for" element={<LookingFor />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
